import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram, FaMedium, FaGlobe, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import ProfileCard from './components/ProfileCard';

// Styled components
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  color: white;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

const Content = styled(motion.div)`
  max-width: 600px;
  width: 100%;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Avatar = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.2);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Name = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  background: linear-gradient(90deg, #ffffff, #a0a0a0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  opacity: 0.8;
`;

const Bio = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto 2rem;
  opacity: 0.7;
`;

const Footer = styled.footer`
  margin-top: 3rem;
  text-align: center;
  font-size: 0.9rem;
  opacity: 0.6;
`;

function App() {
  const profiles = [
    {
      title: 'WhatsApp',
      username: '+971 55 217 4890',
      url: 'https://wa.me/971552174890',
      icon: <FaWhatsapp />,
      color: '#25D366'
    },
    {
      title: 'LinkedIn',
      username: 'swajannn',
      url: 'https://www.linkedin.com/in/swajannn/',
      icon: <FaLinkedin />,
      color: '#0077B5'
    },
    {
      title: 'Twitter',
      username: '@swajannn',
      url: 'https://twitter.com/swajannn',
      icon: <FaTwitter />,
      color: '#1DA1F2'
    },
    {
      title: 'Facebook',
      username: 'swajannn',
      url: 'https://facebook.com/swajannn',
      icon: <FaFacebook />,
      color: '#1877F2'
    },
    {
      title: 'Instagram',
      username: '@swajannnn',
      url: 'https://www.instagram.com/swajannnn',
      icon: <FaInstagram />,
      color: '#E4405F'
    },
    {
      title: 'Website',
      username: 'swajannn.com',
      url: 'http://swajannn.com/',
      icon: <FaGlobe />,
      color: '#333333'
    },
    {
      title: 'Medium',
      username: '@swajannn',
      url: 'https://medium.com/@swajannn',
      icon: <FaMedium />,
      color: '#12100E'
    },
    {
      title: 'Email',
      username: 'hello@swajannn.com',
      url: 'mailto:hello@swajannn.com',
      icon: <FaEnvelope />,
      color: '#EA4335'
    }
  ];

  return (
    <Container>
      <Content
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <Header>
          <Avatar>
            <img src="/swajannn-swajan.jpeg" alt="Swajan" />
          </Avatar>
          <Name>Swajan</Name>
          <Title>Creator & Innovator</Title>
          <Bio>
            Building seamless digital experiences through AI, automation, tech, and creativity.
          </Bio>
        </Header>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          {profiles.map((profile, index) => (
            <ProfileCard
              key={index}
              title={profile.title}
              username={profile.username}
              icon={profile.icon}
              url={profile.url}
              color={profile.color}
              index={index}
            />
          ))}
        </motion.div>

        <Footer>
          <p>© {new Date().getFullYear()} Swajan • <a href="http://swajannn.com" style={{ color: 'inherit', textDecoration: 'none' }}>www.swajannn.com</a></p>
        </Footer>
      </Content>
    </Container>
  );
}

export default App;
